import Picker from 'react-mobile-picker'
import React, { FC, useEffect, useState } from 'react'

type PropsNumberWheel = {
  value: number
  disabled: boolean
  inputClass:string
  onChange: (value: number) => void
  min?: number
  max?: number
}

export const NumberWheel:FC<PropsNumberWheel> = ({ value, disabled, inputClass, onChange, min = 0, max = 100}) => {

    const [open, setOpen] = useState(false)
    const [temp, setTemp] = useState(value)


    useEffect(() => {
      const preventTouch = (e: TouchEvent) => e.preventDefault()
  
      if (open) {
        document.body.style.overflow = 'hidden'
        document.addEventListener('touchmove', preventTouch, { passive: false })
      }
  
      return () => {
        document.body.style.overflow = ''
        document.removeEventListener('touchmove', preventTouch)
      }
    }, [open])
  
  
    const numbers = Array.from(
      { length: max - min + 1 },
      (_, i) => min + i
    )
  
    useEffect(() => {
      setTemp(value)
    }, [value])
  
    const acceptScore = (e: React.MouseEvent) => {
        onChange(temp)
        setOpen(false)
    }

    return (
        <div style={{position:'relative'}}>
          <input
            readOnly
            value={value}
            onClick={() => setOpen(true)}
            className={inputClass}
            disabled = {disabled}
          />
    
          {open && (
            <>               
                <div
                    className="picker-backdrop"
                    onClick={acceptScore}
                  >
                  </div>
                  <div className="picker-container">
                  <Picker
                    value={{ number: temp }}
                    onChange={(x) => setTemp(x.number)}
                    wheelMode="natural"
                    itemHeight={40}
                  >
                    <Picker.Column name="number">
                      {numbers.map(x => (
                        <Picker.Item key={x} value={x} onClick={acceptScore}>
                          <div className={`picker-item ${temp == x?'active':''}`}>{x}</div>
                        </Picker.Item>
                      ))}
                    </Picker.Column>
                  </Picker>
                </div>
            </>

          )}
        </div>
      )
};
